/* eslint-disable */
require('./atoms')
require('./circle-split')
require('./circle-x')
require('./color-palette')
require('./cube-grid')
require('./cube-solid')
require('./cube-triangles')
require('./factory')
require('./ground')
require('./milling-gear')
require('./move')
require('./pause')
require('./play')
require('./rotate-ccw')
require('./rotate-cw')
require('./svg-analysis-report')
require('./svg-basic-rack')
require('./svg-calculator')
require('./svg-carrier-circles2')
require('./svg-curly-brackets')
require('./svg-dh-logo-333333')
require('./svg-folder-files')
require('./svg-gear-a')
require('./svg-gear-b-internal')
require('./svg-gears2')
require('./svg-gears3')
require('./svg-globe')
require('./svg-gps-indicator')
require('./svg-link')
require('./svg-lock-off-b')
require('./svg-lock-on')
require('./svg-mesh')
require('./svg-powerflow')
require('./svg-print-3d')
require('./svg-report-gears')
require('./svg-saw-circular-b')
require('./svg-saw-circular')
require('./svg-set-square')
require('./svg-shaft')
require('./svg-shaft2')
require('./svg-shaper')
require('./svg-table-grid')
require('./svg-tools')
require('./svg-vibration')
require('./user-tie')
